<p-dialog
    id="global-dro-tnc-dialog"
    header="Global DRO Terms and Conditions"
    [visible]="showDialog()"
    [modal]="true"
    [closable]="false"
    [draggable]="false"
    [resizable]="false"
    [focusOnShow]="false"
    [style]="{ width: '650px', maxHeight: '90vh' }">

    <div class="tnc-content">
        <h3>TERMS AND CONDITIONS</h3>

        <p>
            Global DRO provides the prohibited status of medication brands and ingredients according to
            the current World Anti-Doping Agency's Prohibited List.
        </p>

        <p>
            Global DRO only provides brand information for medications available for purchase in Australia,
            Canada, Japan, New Zealand, Switzerland, UK, and USA.
        </p>

        <p>
            Global DRO does <strong>NOT</strong> contain information on, or that applies to, any dietary
            supplement unless an ingredient on the label is known to be prohibited. The same applies to
            homeopathic products and other alternative medicines.
        </p>

        <p>
            A dietary supplement may contain prohibited substances even if your search results for all
            individual ingredients state that the ingredients on the label are not prohibited or the
            ingredients are not contained in Global DRO. Dietary supplements may contain ingredients which
            are not listed on the ingredient label or may use alternate names for a prohibited ingredient
            which do not appear in Global DRO. The use of any dietary supplement is at your own risk.
        </p>

        <p>
            Global DRO does not reflect additional disciplinary regulations, published by International
            Federations or Major Event Organizers, which prohibit certain ingredients or methods separate
            to their status under the World Anti-Doping Agency Prohibited List.
        </p>

        <p>
            If you can't find your medication on Global DRO this does <strong>NOT</strong> mean your
            product is safe to take in sport.
            <a href="https://www.globaldro.com/UK/search/Contact?changelang=en-us" class="underline" target="_blank" rel="noopener noreferrer"
                >Contact us</a>
            to find out if it is prohibited in sport.
        </p>

        <p>
            Please read the full
            <a href="https://www.globaldro.com/UK/search/terms" class="underline" target="_blank" rel="noopener noreferrer"
                >Global DRO Terms and Conditions</a>
            which contain additional information which is essential to your proper use of Global DRO.
            By using our site, you consent to the level of protection set out in the
            <a href="https://www.globaldro.com/Home/Privacy?changelang=en-us" class="underline" target="_blank" rel="noopener noreferrer"
                >Privacy Policy</a>.
            Please click accept to continue.
        </p>

        @if (showDeclineWarning()) {
            <div class="decline-warning p-3 flex align-items-start gap-3 border-round">
                <p class="m-0">
                    To continue using prescriptions, you must accept the terms before proceeding.
                </p>
            </div>
        }
    </div>

    <ng-template pTemplate="footer">
        <div class="p-fluid">
            <div class="flex justify-content-between align-items-center w-100">
                <p-button
                    styleClass="p-button-secondary"
                    [text]="true"
                    [label]="declineButtonLabel()"
                    [disabled]="isProcessing()"
                    (click)="onDecline()">
                </p-button>

                <p-button
                    class="m-button-primary btn-orb-orange"
                    label="Accept"
                    [loading]="isProcessing()"
                    [disabled]="isProcessing()"
                    (click)="onAccept()">
                </p-button>
            </div>
        </div>
    </ng-template>
</p-dialog>